<template>
  <div>
    <PresentationTranslator
      v-if="translator.isActive"
      :translator="translator"
    />
    <StandardView
      v-if="version === versions.standard"
      :renderParams="renderParams"
      :version="version"
      :localeService="localeService"
    />
    <PrintView
      v-else-if="version === versions.print"
      :renderParams="renderParams"
      :version="version"
      :localeService="localeService"
    />
    <TableView
      v-else-if="version === versions.table"
      :renderParams="renderParams"
      :version="version"
      :localeService="localeService"
    />
    <div v-if="toShowBrand" class="ww-branding">
      Сделано с помощью
      <a href="https://winwin-tech.ru/" target="blank">WinWinTech</a>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import StandardView from './StandardView/StandardView.vue'
import TableView from './TableView/TableView.vue'
import PrintView from './PrintView/PrintView.vue'
import PresentationTranslator from './PresentationTranslator.vue'
import Locale from '../../services/locale'

export default {
  name: 'Presentation',
  components: {
    StandardView,
    TableView,
    PrintView,
    PresentationTranslator,
  },
  props: {
    version: String,
    renderParams: Object,
    localeService: Locale,
  },
  computed: {
    translator() {
      return this.renderParams?.config?.translator || {}
    },
    toShowBrand() {
      return (
        [this.versions.table, this.versions.standard].includes(this.version) &&
        this.renderParams.config.toBrandPres
      )
    },
  },
  setup() {
    return {
      versions: {
        standard: 'standard',
        print: 'print',
        table: 'table',
      },
    }
  },
  async mounted() {
    document.body.classList.add(`presentation-${this.version}-view`)

    const customScript = this.renderParams.config?.script
    if (!customScript) {
      return
    }

    try {
      $(document.body).append($(customScript))
    } catch (e) {
      console.error(e)
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');

.ww-branding {
  border-top: 1px solid #7a7a7a;
  font-size: 0.9em;
  font-weight: 400;
  font-family: Inter;
  height: 4.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ww-branding > a {
  padding-left: 0.2rem;
  color: cornflowerblue;
  text-decoration: underline;
}
</style>
